<div id="{{theme}}-app" class="{{theme}}-agree-popup">
  <div class="{{theme}}-dialog-modal-header">Please read the following Connected Technology Terms of Use in its entirety. You must accept the terms of this agreement
    before continuing
  </div>
  <mat-dialog-content class="{{theme}}-dialog-modal-content">
    <div class="{{theme}}-dialog-modal-title">CONNECTED TECHNOLOGY SUPPORT
      <br> TERMS OF USE
    </div>
    <div class="{{theme}}-dialog-modal-data">
      By logging into the Connected Technology Support portal,I understand that I may be accessing confidential and proprietary
      information of {{org}} and I agreed to use this information for legitimate business purposes only. I further understand
      that misuse of any information contained in this portal may result in my access being suspended or terminated
    </div>
  </mat-dialog-content>
  <br>
  <div>
    <mat-checkbox (change)="checkboxChange($event.checked)">
      <div class="{{theme}}-dialog-modal-footer">I have read and agree to the Connected Technology Support Terms of Use
      </div>
    </mat-checkbox>
  </div>
  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="btn btn-default" (click)="updateAuditLog()" [disabled]='!isAccepted'>
      Accept
    </button>
    <button mat-button mat-dialog-close (click)="onLogout()" class="btn btn-secondary">Decline</button>
  </mat-dialog-actions>

</div>